import { useTranslation } from 'react-i18next';

interface ILanguage {
	id: string;
	shortcode: string;
}

export const Kakapo2Treams: Record<string, string> = {
	nl: 'nl_NL',
	en: 'en_US',
	de: 'de_DE',
	fr: 'fr_FR',
};

export const Treams2Kakapo: Record<string, string> = {
	nl_NL: 'nl',
	en_US: 'en',
	de_DE: 'de',
	fr_FR: 'fr',
};

const useLanguage = (): ILanguage => {
	const { i18n } = useTranslation();

	return {
		id: Kakapo2Treams[i18n.language],
		shortcode: i18n.language,
	};
};

export default useLanguage;
